import React, { useEffect, useState } from "react";
import BgBox from "../../../common/BgBox";
import HeaderText from "../../../common/HeaderText";
import CardUI from "../../../common/Card";
import { Box, Grid, Typography, Link } from "@mui/material";
import Textfield from "../../../common/Textfield";
import { Link as LinkTo, useLocation, useNavigate } from "react-router-dom";
import AlertMessage from "../../../common/AlertMessage";
import { useDispatch, useSelector } from "react-redux";
import {
  createWorkspaceFunc,
  getAgentProfile,
  updateAgentProfile,
} from "../../../actions/Agency";
import MccLogo from "../../../components/MccLogo";
import Cookies from "js-cookie";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { BASE_URL } from "../../../actions";
const skipBilling =  false;


const CreateAgentName = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location?.state;
  const agentData = state?.agentData;

  const agentId = Cookies.get("agent_id_vita");
  const organizationId = Cookies.get("org_id_vita");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState(null);
  const [isTouched, setIsTouched] = useState(false);

  const dispatch = useDispatch();
  const agentUpdateProfile = useSelector((state) => state.agentUpdateProfile);
  const { loading, error: errorUpdate, agentInfo } = agentUpdateProfile;

  const agentProfile = useSelector((state) => state.agentProfile);
  const {
    loading: loadingAgentProfile,
    error: errorAgentProfile,
    agentUser,
  } = agentProfile;

 const callSecretKeyFunc = async (name, email) => {
    if (skipBilling) {
      navigate("/password-created?billingCompleted=true");
      return;
    }
 
    const data = await secretKeyCallFunction(name, email);
 
    if (data?.ok) {
      navigate("/billing-details", {
        state: { billingCompleted: true, client_secret: data?.client_secret },
      });
    }
  };

  useEffect(() => {
    if (agentInfo?.ok) {
      const agent = Array.isArray(agentInfo.agent)
        ? agentInfo.agent[0]
        : agentInfo.agent;
      const fullName =
        agent?.name ||
        `${agent?.first_name || firstName || ""} ${
          agent?.last_name || lastName || ""
        }`.trim();
      callSecretKeyFunc(fullName, agent?.email);
    }
  }, [agentInfo]);

  const secretKeyCallFunction = async (name, email) => {
    try {
      const token = Cookies.get("token");
      if (token) {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const customerObj = {
          organization_id: Cookies.get("org_id_vita") || organizationId,
          email,
          name,
        };

        const response = await axios.post(
          `${BASE_URL}/subscription/create-customer`,
          customerObj,
          config
        );
        if (!response?.data?.ok) {
          throw new Error(response?.data?.msg || response?.data?.message);
        }

        return response?.data;
      }
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  useEffect(() => {
    if (state === null) {
      navigate(-1);
      return;
    }
    Cookies.set("route", "/create-agentname");
  }, []);

  const [open, setOpen] = useState(true);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const createNameHandler = async (e) => {
    e.preventDefault();

    setIsTouched(true);

    if (!firstName) {
      setError("Please enter your first name");
      return;
    }

    const data = {
      first_name: firstName,
      last_name: lastName,
    };

    const agentData = {
      agent_id: agentId,
      agent_profile: data,
    };

    dispatch(updateAgentProfile(agentData));
    setOpen(true);
    setError("");
  };

  if (state === null) {
    return;
  }

  return (
    <>
      {!loading && errorUpdate && (
        <AlertMessage
          message={errorUpdate}
          severity="error"
          open={open}
          handleClose={handleClose}
        />
      )}

      {/* !loading && */}
      {!loading && error && (
        <AlertMessage
          message={error}
          severity="error"
          open={open}
          handleClose={handleClose}
        />
      )}

      <BgBox>
        <CardUI maxWidth={570} paddingTop="86px">
          {/* MCC LOGO */}
          <MccLogo />

          <Grid container component="main">
            <Box
              component="form"
              onSubmit={createNameHandler}
              xs={12}
              display="flex"
              gap="40px"
              flexDirection="column"
              width="100%"
            >
              <Box>
                <Typography
                  variant="body1"
                  className="d-flex"
                  fontSize={16}
                  mb="16px"
                  color="#566875"
                >
                  Step 2 of 2
                </Typography>
                <HeaderText
                  variant="h3"
                  fontSize={48}
                  textContent="What's your name?"
                  lineHeight="116.7%"
                  textAlign="initial"
                />
                <Typography
                  variant="body1"
                  className="d-flex"
                  fontSize={16}
                  mt="16px"
                  color="#566875"
                >
                  Adding your name and profile photo helps your teammates
                  recognize and connect with you more easily.
                </Typography>
              </Box>

              <Box display="flex" gap="16px" width="100%">
                <Textfield
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  variant="outlined"
                  label="First Name"
                  name="firstName"
                  width="100%"
                  errorContent={
                    error && !firstName && "Please enter first name"
                  }
                />
                <Textfield
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  variant="outlined"
                  label="Last Name"
                  name="lastName"
                  width="100%"
                />
              </Box>
              <LoadingButton
                fullWidth
                loading={loading}
                type="submit"
                variant="contained"
                sx={{ padding: "8px 22px", fontSize: 15 }}
              >
                Next
              </LoadingButton>

              {/* <Button
            className="w-100"
            fontSize="15px"
            color="primary"
    
            title="Sign In"
            variant="contained"
            width="100%"
            height="48px"
            // disabled={!fieldVals?.email || !fieldVals?.password} // Disabling it off on purpose
            // onClick={() => onSignIn()}
            // loading={signInLoading}
            loadingColor="primary"
          /> */}
            </Box>
          </Grid>
        </CardUI>
      </BgBox>
    </>
  );
};

export default CreateAgentName;
